module.exports = __webpack_public_path__ + "static/img/icon_delete.58b65a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common-icons/icon_delete.svg
// module id = nVSB
// module chunks = 1